<script lang="ts">
import type { ToastInstance } from "@/types"
import { defineComponent, h, provide, Teleport, useSlots } from "vue"
import { StyledToast } from "@/components/ui"
import { ToastScope } from "@/components/ui/Toast/ToastScope"
import { ToastInjectionKey } from "@/symbols"

export default defineComponent({
  setup() {
    const slots = useSlots()

    const scope = new ToastScope(true)

    provide(ToastInjectionKey, scope)

    return () => {
      return h("div", [
        slots.default?.(),
        h(
          Teleport,
          { to: "body" },
          h(
            "div",
            { class: "gpx-toast-container" },
            scope.toasts.value.map(toast =>
              h(
                StyledToast,
                toast.slot
                  ? {
                      toast,
                      ...toast.attrs,
                      onHide: (toast: ToastInstance) => toast.hide?.(),
                    }
                  : {
                      toast,
                      ...toast.attrs,
                      onHide: (toast: ToastInstance) => toast.hide?.(),
                      textContent: toast.content,
                    },
                toast.slot ? () => toast.slot?.({ title: toast.title, content: toast.content }) : undefined,
              ),
            ),
          ),
        ),
      ])
    }
  },
})
</script>
